import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { getRandomKey } from "../utils";
export var EventBus = /*#__PURE__*/ function() {
    "use strict";
    function EventBus() {
        _class_call_check(this, EventBus);
        _define_property(this, "eventBus", {});
        _define_property(this, "handleMap", {});
    }
    _create_class(EventBus, [
        {
            /** 制造一个事件 */ key: "emit",
            value: function emit(event, data) {
                var _this = this;
                if (this.eventBus[event]) {
                    Object.keys(this.eventBus[event]).forEach(function(handleId) {
                        _this.eventBus[event][handleId](data);
                    });
                }
            }
        },
        {
            /** 取消一个订阅，如果传入句柄则取消某一个订阅 */ key: "off",
            value: function off(eventOrHandleId) {
                if (this.eventBus[eventOrHandleId]) {
                    delete this.eventBus[eventOrHandleId];
                } else {
                    var event = this.handleMap[eventOrHandleId];
                    if (event) {
                        delete this.eventBus[event][eventOrHandleId];
                        delete this.handleMap[eventOrHandleId];
                    }
                }
            }
        },
        {
            key: "on",
            value: function on(event, callback) {
                if (!this.eventBus[event]) {
                    this.eventBus[event] = {};
                }
                var handleId = getRandomKey();
                this.eventBus[event][handleId] = callback;
                this.handleMap[handleId] = event;
                return handleId;
            }
        }
    ]);
    return EventBus;
}();
